/**
 * @file 店舗一覧ページ内リンク
 */
'use strict';
// utility class
import Common from '../util/_common';

/**
 * @classname ShopPageLinkView
 * @classdesc 店舗一覧ページ内リンク
 */
export default class ShopPageLinkView {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('ShopPageLinkView.constructor');
		this._$e = $e;
		if($(window).width() < 768){
			this.sp();
		}
	};


	/**
	 * PCでのページ内リンク
	 *
	 * @memberof ShopPageLinkView
	 * @return {undefined}
	 */
	sp() {
		console.log('ShopPageLinkView.sp');
		const url = location.href;
		if (url.match(/(.+)#/)) {
			const match = url.match(/(.+)#(.+)/);
			const target = match[2];
			console.log(target);
			const $target = $(`#${target}`);
			$target.addClass('open').next('.list').slideDown();
		}
	};

}
